<template>
  <side-panel-inner headerTitle="Invite Users" class="p-form-create">
    <template slot="actions">
      <base-button @click="onInvite" :primary="true">Invite</base-button>
    </template>

    <div v-if="question.private && question.user.id !== $store.state.auth.currentUser.id">
      <h1>Permission denied</h1>
      <p>Sorry, you do not have permission to invite users.</p>
    </div>

    <!-- Policy Title -->
    <form v-else-if="!loading" action>
      <message type="error" v-if="showValidationMessage">
        <h3>Form Invalid</h3>
        <p>Form is invalid, please check and try again.</p>
        <ul>
          <li v-for="error in errors.items" :key="error.id">{{error.msg}}</li>
        </ul>
      </message>

      <form-field
        full-width
        required
        label="Invite Users"
        helper-text="Select users to invite to this question"
      >
        <user-select
          v-model="question.users"
          id="users"
          name="users"
          v-validate="{required: true}"
          data-vv-as="user"
          :error="errors.first('users')"
          multiple
          @input="onUserAdd"
        />
      </form-field>
    </form>
  </side-panel-inner>
</template>

<script>
import UserSelect from "@/components/UserSelect";
import { mapState } from "vuex";

export default {
  name: "question-create",

  data() {
    return {
      showValidationMessage: false,
      loading: false
    };
  },

  methods: {
    onUserAdd(val) {
      this.question.user_ids = val.map(val => val.id);
    },

    onInvite() {
      const vm = this;
      this.$store
        .dispatch("Questions/invite", {
          questionId: this.$route.params.questionId,
          userIds: this.userIds
        })
        .then(resp => {
          vm.$store.dispatch(
            "notifications/create",
            {
              body: `Your invite was sent successfully`,
              type: "success"
            },
            { root: true }
          );
          this.$store.dispatch("CLOSE_PANEL");
        })
        .catch(err => {
          vm.$store.dispatch(
            "notifications/create",
            {
              body: `There was a problem sending your invite - ${err}`,
              type: "error"
            },
            { root: true }
          );
        });
    }
  },

  computed: {
    ...mapState("Questions", ["question"]),

    ...mapState({
      users: state => state.users.collection
    }),
    userIds: {
      get() {
        const ids = this.question.users.map(val => val.id);
        this.question.user_ids = ids;
        return ids;
      },
      set(val) {
        this.question.user_ids = val;
      }
    }
  },

  components: {
    UserSelect
  },


  beforeCreate() {
    // this.$store.dispatch("forms/retrieveCategories");
    this.$store.dispatch("users/list");
    this.$store.dispatch("Questions/read", this.$route.params.questionId);
  },

};
</script>


<style lang="scss" scoped>
.p-form-create {
  background-image: url(/assets/qmark.svg);
  background-position: 0 100px;
  background-attachment: scroll;

  form {
    margin-left: 70px;
  }
}
</style>

<style lang="scss">
.ql-toolbar {
  background: $colour-nhs-pale-grey;
}
.ql-container {
  background: $colour-nhs-core-white;
  font-size: 16px;

  @media (min-width: 768px) {
    font-size: 13px;
  }
}
</style>
